// src/services/supportService.js
import axiosInstance from "../api/axiosInstance";

// ✅ Submit support request
//export const submitSupportRequest = (userId, payload) => {
 // userId is no longer needed; backend uses JWT
 // return axiosInstance.post("/client/support", payload);
//};

// ✅ Get support ticket history
export const getSupportHistory = () => {
 return axiosInstance.get("/client/support/history");
};

// ✅ Get all replies for a ticket (client endpoint)
export const getTicketReplies = (ticketId) => {
 return axiosInstance.get(`/client/support/${ticketId}/replies`);
};

// ✅ Send a reply as user
export const replyToTicketAsUser = (ticketId, message) => {
 return axiosInstance.post(
 `/client/support/${ticketId}/reply`,
 message,
 { headers: { "Content-Type": "text/plain" } }
 );
};

// ✅ Submit support request
export const submitSupportRequest = (payload) => {


 return axiosInstance
 .post("/client/support", payload)
 .then((res) => {

 return res;
 })
 .catch((err) => {

 throw err;
 })
 .finally(() => {
 
 });
};
